module.exports = __webpack_public_path__ + "static/img/vFive5.436571d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vFive5.png
// module id = w+ab
// module chunks = 2